import { render } from "./MarkRed.vue?vue&type=template&id=6f729434"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/MarkRed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f729434"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f729434', __exports__)) {
    api.reload('6f729434', __exports__)
  }
  
  module.hot.accept("./MarkRed.vue?vue&type=template&id=6f729434", () => {
    api.rerender('6f729434', render)
  })

}


export default __exports__